// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/AvatarChoice/index.css
// module id = 2486
// module chunks = 0